import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {MatomoTracker} from "@ngx-matomo/tracker";

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  selectedLang$ = new BehaviorSubject<{
    code: string;
    icon: string;
  } | null>(null);
  lang: string = '';
  constructor(private tracker: MatomoTracker) {
    const langStored = localStorage.getItem('segnalazioniLang');
    if (langStored) {
      this.selectedLang$.next(JSON.parse(langStored));
      this.lang = JSON.parse(langStored).code;
    } else {
      this.lang = navigator.language.slice(0, 2);
      this.selectedLang$.next({
        code: navigator.language.slice(0, 2).toLowerCase() === 'en' ? 'en-GB' : 'it-IT',
        icon: `${navigator.language.slice(0, 2).toLowerCase() === 'en' ? 'en-gb' : 'it-it'}-icon`,
      });
    }
  }

  setLang(data: { code: string; icon: string }) {
    this.tracker.trackEvent('internazionalizzazione', 'Cambio Lingua', `${data.code}`);
    localStorage.setItem('segnalazioniLang', JSON.stringify(data));
    this.lang = data.code;
    this.selectedLang$.next(data);
  }
}
